/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../../../../common';
import Component from 'flarum/common/Component';
import AbstractResponsiveComponent from './AbstractResponsiveComponent';

const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.banner.components.image`;

class BannerImageContent extends Component {
	view() {
		const { deviceData, deviceKey, self } = this.attrs;

		if (deviceKey !== 'default') {
			return null;
		}

		const { tablet, phone } = self.attrs.banner.visual().image;

		const phoneMedia = '(max-width: 479px)';
		let tabletMedia = '(max-width: 991.98px)';
		if (!phone) {
			tabletMedia = `(max-width: 991.98px) and (min-width: 480px)`;
		}

		const position = self.attrs.banner.props().setup.position;
		const isSponsoredBanner = ['sponsor_above_reviews', 'sponsor_below_reviews', 'sponsor_between_community_events'].includes(position);

		if (position !== 'slider' && !isSponsoredBanner) {
			// We restrict tablet to use the default image on "large phone" (480px - 767px)
			tabletMedia = `(max-width: 991.98px) and (min-width: 768px)`;
		}

		let alt = self.attrs.banner.visual()?.alt?.default;
		if (!alt) {
			alt = t(`${prfx}.default_alt`);
		}

		return (
			<picture className={this.attrs.className}>
				{phone && <source media={phoneMedia} srcset={phone} />}
				{tablet && <source media={tabletMedia} srcset={tablet} />}
				<img src={deviceData} alt={alt} />
			</picture>
		);
	}
}

export default class BannerImage extends AbstractResponsiveComponent {
	get data() {
		return this.attrs.banner.visual()?.image;
	}

	getClassName() {
		return `${super.className} BannerImage`;
	}

	get content() {
		return BannerImageContent;
	}
}
